import React from "react";
import { PrescriptionIcon } from "../../features/patient-panel/prescriptions";

interface UploadRecord {
  reportName: string;
  reportData: string;
}

interface HealthRecord {
  recordId: number;
  doctorNameOrLabName: string;
  uploadRecords: UploadRecord[];
}

interface Props {
  loading: boolean;
  healthRecords: HealthRecord[];
  handleViewPrescription: (base64: string) => void;
}

const HealthRecordsList: React.FC<Props> = ({
  loading,
  healthRecords,
  handleViewPrescription,
}) => {
  const noRecords =
    !loading &&
    healthRecords.every((record) => record.uploadRecords.length === 0);

  return (
    <div className="bg-white rounded-lg p-6 shadow mb-6">
      <h2 className="font-bold text-xl mb-3">Uploaded health records</h2>

      {loading && <p className="text-muted-foreground">Loading...</p>}
      {noRecords && <p className="text-muted-foreground">No health records</p>}

      <div className="grid gap-4 sm:grid-cols-2 mt-4">
        {healthRecords.map((record) => (
          <div
            key={record.recordId}
            className="border rounded-md p-4 shadow hover:shadow-md transition"
          >
            <p className="font-medium mb-2">
              Consulted with {record.doctorNameOrLabName}
            </p>

            <div className="flex flex-wrap gap-2">
              {record.uploadRecords.map((upload, idx) => (
                <div
                  key={idx}
                  className="border bg-gray-50 rounded-md p-3 flex flex-col items-center cursor-pointer hover:shadow"
                  onClick={() => handleViewPrescription(upload.reportData)}
                >
                  <PrescriptionIcon />
                  <p className="font-bold text-gray-600 text-sm text-center mt-1">
                    {upload.reportName}
                  </p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HealthRecordsList;
